import { createSlice } from '@reduxjs/toolkit';
import { TableState } from '../../components/table/model';

const initialState: TableState = {
  columns: [],
};

const endsystemListSlice = createSlice({
  name: 'endsystemTable',
  initialState,
  reducers: {
    hideColumn(state) {},
  },
});

export const endsystemsReducer = endsystemListSlice.reducer;
